import script from "./VuetifyDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./VuetifyDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./VuetifyDatePicker.vue?vue&type=style&index=0&id=627bc2d0&lang=css"

const __exports__ = script;

export default __exports__